import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import TrimmisHeader from '../TrimmisHeader.js';
import TimeslotSelector from "./TimeslotSelector";
import BooktimeForm from './BooktimeForm';
import DigitalBookerApiClient from '../../utils/digital-booker-api-client';

import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import './booking.css';
import BookingDataLoader from './BookingDataLoader'
import MultiDataSelector from './MultiDataSelector';


class BookTime extends Component {
  constructor(props) {
    super(props);
    moment.locale(this.props.language);

    this.state = {
      loadingData: false,
      ajaxError: false,
      selections: {},
      views: [],
      extraFields: [],
      search: {},
      services: [],
      locations: [],
      categories: [],
      resources: [],
      availableTimes: [],
      selectedDate: undefined
    };
    this.updateCurrentDay  = this.updateCurrentDay.bind(this);
    this.updateSelection = this.updateSelection.bind(this);
    this.loadData = this.loadData.bind(this);
    this.handleAjaxError = this.handleAjaxError.bind(this);

    this.apiClient = new DigitalBookerApiClient(this.props.systemName, this.props.language, this.handleAjaxError);
    this.dataLoader = new BookingDataLoader(this.props.systemName, this.props.language, this.apiClient);
  }

  componentDidMount() {
    this.setState({
      loadingData: true
    });
    return this.loadData({selections: {}});
  }

  updateCurrentDay(date) {
    this.updateSelection("selectedDate", date);
  }

  loadData(newState) {
    return this.dataLoader.loadAllData(newState)
        .then(newState => {
            this.setState(() => {
                newState.loadingData = false;
                return newState;
            })
        }).catch(error => {
          this.handleAjaxError(error);
        });
  }

  handleAjaxError(error) {
    console.log("error while doing ajax: ", error);
    this.setState({ajaxError: true});
  }

  updateSelection(name, value) {
    const newState = cloneDeep(this.state);
    newState.selections[name] = value;
    this.setState({
      loadingData: true,
      selections: newState.selections
    });
    return this.loadData(newState);
  }


  render() {
    const selections = this.state.selections;
    const availableExtraServices = () => {
      return  this.state.selections.service ? this.state.selections.service.extra_services: undefined;
    };
    const selectableOptions = [
      {name: 'location', options: this.state.locations, optionNameField: 'name', placeHolder: "Salonki", selectedOption: this.state.selections.location, visible: () => true},
      {name: 'view', options: this.state.views, optionNameField: 'name', placeHolder: "Laji", selectedOption: this.state.selections.view,
        visible: () => this.state.views.length > 1},
      {name: 'category', options: this.state.categories, optionNameField: 'name', placeHolder: "Rotu", selectedOption: this.state.selections.category, visible: () => true, searchable: true},
      {name: 'service', options: this.state.services, optionNameField: 'name', placeHolder: "Palvelu", selectedOption: this.state.selections.service, visible: () => true},
      {name: 'extra_services', multiOptions: availableExtraServices, optionNameField: 'name', placeHolder: "Lisäpalvelut",
        selectedOption: this.state.selections.extra_services,
        visible: () => selections.service !== undefined && selections.service.extra_services  !== undefined && selections.service.extra_services.length > 0},
      {name: 'resource', options: this.state.resources, optionNameField: 'name', placeHolder: "Trimmisläinen", selectedOption: this.state.selections.resource, visible: () => true},
    ];

    const calendarElement = () => {
      if(selections.resource !== undefined) {
        return <TimeslotSelector loadingData={this.state.loadingData} updateState={this.updateSelection.bind(this)} date={this.state.selections.selectedDate} language={this.props.language} availableTimes={this.state.availableTimes} onDateChange={this.updateCurrentDay} selections={this.selections} apiClient={this.apiClient}/>
      } else {
        return <span/>
      }
    };

    const bookATimeElement = () => {
      return this.state.selections.service && this.state.selections.service.phone_only
          ? <div className="booking-via-phone">Varaa aika puhelimitse <a href={"tel://"+this.state.selections.location.phone}>{this.state.selections.location.phone}</a></div>
          : <div className="booking-calendar">{calendarElement()}</div>;
    };

    const selectDataView = () => {
      return (
          <div>
              <h2 className="booktime-intro-text">Valitse ensin salonki, rotu ja palvelu, niin näet hinnat ja vapaat ajat</h2>
              <MultiDataSelector options={selectableOptions} loadingData={this.state.loadingData} onOptionSelection={this.updateSelection}/>
              <div className="content-margin-20">
                {bookATimeElement()}
              </div>
          </div>);
    };

    const finishBookingView = () => {
      return (<BooktimeForm apiClient={this.apiClient} updateState={this.updateSelection.bind(this)} language={this.props.language} systemName={this.props.systemName} selections={selections} extraFields={this.state.extraFields}/>);
    };

    const view = this.state.selections.time_slot === undefined ? selectDataView() : finishBookingView();

    const iframeBookingSystem =  () => {
        const iFrameStyle = {
            width: '100%',
            height: '100vh'
        };

      return (
          <div className="container">
              <iframe id="booking-iframe" src={"https://www.varaaheti.fi/"+this.props.systemName+"/"+this.props.language} style={iFrameStyle}/>
          </div>
      );
  };

    return (
        <div className="trimmis-main-container container">
              <TrimmisHeader fixedClass="trimmis-static-logo" normalClass="trimmis-static-logo"/>
              {this.state.ajaxError ? iframeBookingSystem() : view}
        </div>
    );
  }
}

export default BookTime;


// WEBPACK FOOTER //
// ../components/booking/BookTime.js